<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <legend>Tutor Personal Detail</legend>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">First Name</label>
              <v-text-field v-model="data.first_name" :error-messages="errors.first_name" label="First Name"
                placeholder="First Name" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Last Name</label>
              <v-text-field v-model="data.last_name" :error-messages="errors.last_name" label="Last Name"
                placeholder="Last Name" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Email</label>
              <v-text-field label="Email" v-model="data.email" :error-messages="errors.email" type="email"
                placeholder="Email" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Username</label>
              <v-text-field v-model="data.username" :error-messages="errors.username" label="Username"
                placeholder="Username" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Password</label>
              <v-text-field v-model="data.password" :error-messages="errors.password" label="Password" type="password"
                placeholder="Password" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Contact Number</label>
              <v-text-field label="Contact Number" v-model="data.contact_number" :error-messages="errors.contact_number"
                placeholder="Contact Number" type="number" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Choose Subjects</label>
              <v-select :items="subjects" multiple label="Choose Subjects" v-model="data.subjects_ids"
                :error-messages="errors.subjects_ids" placeholder="Choose Subjects" solo></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Profile Picture</label>
              <v-file-input show-size label="Choose File" @change="imageConvert" :error-messages="errors.profile_picture"
                prepend-icon chips solo accept="image/*"></v-file-input>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Country</label>
              <v-select v-model="data.country" readonly :error-messages="errors.country" :items="countries"
                label="Country" placeholder="Choose Country" solo single-line item-value="country_id"
                item-text="country_name" @input="getStates($event)"></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Post Code</label>
              <v-text-field v-model="data.post_code" :error-messages="errors.post_code" label="Post Code"
                placeholder="Post Code" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">States</label>
              <v-select v-model="data.state" :error-messages="errors.state" :items="states" label="State"
                placeholder="Choose State" solo single-line item-value="states_id" item-text="states_name"
                @input="getCities($event)"></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">City</label>
              <v-select v-model="data.city" :error-messages="errors.city" :items="cities" label="City"
                placeholder="Choose City" solo single-line item-value="city_id" item-text="city_name"></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Address</label>
              <v-text-field label="Address" v-model="data.address" :error-messages="errors.address" placeholder="Address"
                solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">How to deliver the lesson?</label>
              <v-select v-model="data.lesson_type" :error-messages="errors.lesson_type" :items="lesson_type"
                label="Lesson type" placeholder="Lesson type" solo item-value="id" item-text="label"
                single-line></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Joining Date</label>

              <v-dialog ref="dialog" v-model="joining_date_model" :return-value.sync="data.joining_date" persistent
                width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :error-messages="errors.joining_date" clearable v-model="data.joiningDateFormated"
                    label="Select Joining Date" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker :first-day-of-week="1" v-model="data.joining_date" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="joining_date_model = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(data.joining_date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Address Line 2</label>
              <v-text-field
                label="Address Line 2"
                v-model="data.address_2"
                :error-messages="errors.address_2"
                placeholder="Address Line 2"
                solo
              ></v-text-field>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Rating</label>
              <v-rating
                v-model="data.ratting"
                background-color="orange lighten-3"
                color="#F2A711"
                size="35"
              ></v-rating>
            </v-col> -->
          </v-row>
        </fieldset>

        <fieldset>
          <legend>Earning</legend>
          <v-row>
            <!-- <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Days</label>
              <v-select
                v-model="data.days"
                :error-messages="errors.days"
                :items="days"
                label="Days"
                placeholder="Choose Days"
                multiple
                chips
                solo
              ></v-select>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Time</label>
              <v-menu
                ref="menu"
                v-model="timeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="data.time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="data.time"
                    :error-messages="errors.time"
                    label="Picker in menu"
                    prepend-icon
                    v-bind="attrs"
                    v-on="on"
                    solo
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenu"
                  v-model="data.time"
                  full-width
                  @click:minute="$refs.menu.save(data.time)"
                ></v-time-picker>
              </v-menu>
            </v-col> -->
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Per Hour Rate</label>
              <v-text-field label="Earning" v-model="data.per_hour_earning" :error-messages="errors.per_hour_earning"
                placeholder="Earning" solo></v-text-field>
            </v-col>
          </v-row>
          <legend>Week Hours</legend>
          <v-row>
            <v-col>
              <label>Monday</label>
              <v-text-field v-model="data.mon_hours" :error-messages="errors.mon_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
            <v-col>
              <label>Tuesday</label>
              <v-text-field v-model="data.tue_hours" :error-messages="errors.tue_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
            <v-col>
              <label>Wednesday</label>
              <v-text-field v-model="data.wed_hours" :error-messages="errors.wed_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
            <v-col>
              <label>Thursday</label>
              <v-text-field v-model="data.thu_hours" :error-messages="errors.thu_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
            <v-col>
              <label>Friday</label>
              <v-text-field v-model="data.fri_hours" :error-messages="errors.fri_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
            <v-col>
              <label>Saturday</label>
              <v-text-field v-model="data.sat_hours" :error-messages="errors.sat_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
            <v-col>
              <label>Sunday</label>
              <v-text-field v-model="data.sun_hours" :error-messages="errors.sun_hours" label="No Of Hours"
                placeholder="No Of Hours" solo dense></v-text-field>
            </v-col>
          </v-row>
        </fieldset>

        <fieldset>
          <legend>Bank Details</legend>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Bank Name</label>
              <v-text-field label="Bank Name" v-model="data.bank_name" :error-messages="errors.bank_name"
                placeholder="Bank Name" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Account Title</label>
              <v-text-field label="Account Title" v-model="data.account_title" :error-messages="errors.beneficiary_name"
                placeholder="Account title" solo></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Account Number</label>
              <v-text-field label="Account Number" v-model="data.account_number" :error-messages="errors.account_number"
                placeholder="Account Number" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Sort Code</label>
              <v-text-field label="Sort Code" placeholder="Sort Code" v-model="data.sort_code"
                :error-messages="errors.sort_code" solo></v-text-field>
            </v-col>
          </v-row>
        </fieldset>
        <!-- <Loading :active.sync="isLoading" :color="color" :loader="loaderType" :is-full-page="true"></Loading> -->

        <v-row>
          <v-col cols="12">
            <v-btn :loading="loading" @click="save" color="primary">Save</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import Form from "../../utils/form/Form";
import { DAYSSELECTOR } from "../../utils/constants";
import { Countries } from "../../utils/constants";
import moment from "moment";
import Loading from "vue-loading-overlay";


export default {
  name: "TutorForm",
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.getSubjectsList();
    this.getCountries();
  },
  watch: {
    "data.joining_date": function (newVal, oldVal) {

      this.data.joiningDateFormated = moment(this.data.joining_date).format("DD-MM-YYYY");
    },
  },
  data() {
    return {
      joiningDateFormated: "",
      joining_date_model: false,
      color: "#9734fa",
      loaderType: "dots",
      isLoading: true,
      lesson_type: [
        {
          id: 1,
          label: "In-centre",
        },
        {
          id: 2,
          label: "online",
        },
        {
          id: 3,
          label: "Online & In-centre",
        },
      ],

      days: DAYSSELECTOR,
      errors: {},
      subjects: [],
      cities: [],
      states: [],
      data: {
        first_name: "",
        last_name: "",
        joiningDateFormated: "",
        email: "",
        username: "",
        password: "",
        contact_number: "",
        subjects_ids: [],
        profile_picture: null,
        country: 230,
        post_code: "",
        city: "",
        state: "",
        address: "",
        address_2: "",
        ratting: 0,
        days: [],
        time: null,
        per_hour_earning: 0,
        bank_name: "",
        account_title: "",
        account_number: "",
        sort_code: "",
        date: new Date().toISOString().substr(0, 10),
      },
      timeMenu: false,
      countries: Countries,
      loading: true,
    };
  },
  methods: {
    imageConvert(e) {
      var reader = new FileReader();
      reader.readAsDataURL(e);
      reader.onload = () => {
        this.data.image = reader.result;
      };
    },

    getCountries() {
      axios.get(apiRoutes.countries.url).then((response) => {
        this.countries = response.data.countries;
      });
    },
    getStates(item) {
      axios.get(apiRoutes.countries.byCountry + item).then((response) => {
        this.states = response.data;
      });
    },
    getCities(item) {
      axios.get(apiRoutes.cities.byCountry + item).then((response) => {
        this.cities = response.data;
      });
    },
    getSubjectsList() {
      let data = this.$store.getters.subjects;
      data.forEach((element) => {
        this.subjects.push({
          value: element.subject_id,
          text: element.subject_name,
        });
      });
    },
    save() {
      if (this.id) {
        if (!this.data.joining_date) {

          this.data.joining_date = this.joiningDateFormated;
        }
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.tutors.url)
        .then((response) => {
          this.$router.replace({
            name: "Tutors",
            params: {
              id: response.user_id,
            },
          });
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
    update() {
      // alert('ss')
      let form = new Form({
        ...this.data,
      });
      form
        .patch(apiRoutes.tutors.url + "/" + this.id)
        .then((response) => {
          this.$router.replace({
            name: "Tutors",
            params: {
              id: this.id,
            },
          });
        })
        .catch((response) => {
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
  },
  mounted() {
    this.loading = false;
    if (this.id) {
      this.loading = true;

      axios.get(apiRoutes.tutors.url + "/" + this.id).then((response) => {
        this.loading = false;
        this.getStates(response.data.country_id);
        this.getCities(response.data.states_id);

        this.data.first_name = response.data.tutor_fname;
        this.data.last_name = response.data.tutor_lname;
        this.data.email = response.data.tutor_email;
        this.data.username = response.data.tutor_username;
        this.data.password = response.data.tutor_password;
        this.data.contact_number = response.data.tutor_contactno;
        if (
          response.data.joining_date !== null &&
          typeof response.data.joining_date !== "undefined"
        ) {
          // this.data.joining_date =response.data.joining_date);
          this.data.joiningDateFormated = response.data.joining_date;
        }
        this.data.country = parseInt(response.data.country_id);
        this.data.post_code = response.data.tutor_postcode;
        this.data.city = parseInt(response.data.city_id);
        this.data.state = parseInt(response.data.states_id);
        this.data.address = response.data.tutor_street_address;
        this.data.address_2 = response.data.address_2;
        this.data.ratting = response.data.ratting;
        this.data.lesson_type = response.data.lesson_type;
        this.data.days = response.data.days;
        this.data.time = response.data.time;
        this.data.per_hour_earning = response.data.tutor_per_hour_rate;
        this.data.bank_name = response.data.tutor_bankname;
        this.data.account_title = response.data.tutor_account_title;
        this.data.account_number = response.data.tutor_accountno;
        this.data.sort_code = response.data.tutor_sortcode;
        // this.data.sort_code = parseInt(response.data.week_hours.mon);
        if (typeof response.data.week_hours != "undefined") {
          this.data.mon_hours = response.data.week_hours.mon;
          this.data.tue_hours = response.data.week_hours.tue;
          this.data.wed_hours = response.data.week_hours.wed;
          this.data.thu_hours = response.data.week_hours.thu;
          this.data.fri_hours = response.data.week_hours.fri;
          this.data.sat_hours = response.data.week_hours.sat;
          this.data.sun_hours = response.data.week_hours.sun;
        }
        this.isLoading = false
        this.data.subjects_ids = [
          ...response.data.tutor_subject_group.map((subject) =>
            parseInt(subject.subject_id)
          ),
        ];
      });
    } else {
      this.getStates(230);
    }
  },
  components: {
    Loading
  }
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>
